import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// ---- Public ----
export const getEvents = (upcomingOnly = true) => api.get("/events", { params: { upcoming: upcomingOnly } }).then((r) => r.data);
export const getRsvpInfo = (eventId) => api.get(`/events/${eventId}/rsvp-info`).then((r) => r.data);
export const submitRsvp = (eventId, payload) => api.post(`/events/${eventId}/rsvp`, payload).then((r) => r.data);
export const createTicketCheckout = (eventId, payload) => api.post(`/events/${eventId}/ticket-checkout`, payload).then((r) => r.data);
export const adminEventRsvps = (eventId) => api.get(`/admin/events/${eventId}/rsvps`).then((r) => r.data);
export const getStories = (tag) => api.get("/stories", { params: tag && tag !== "All" ? { tag } : {} }).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (payload) => api.post("/newsletter", payload).then((r) => r.data);
export const applyMentee = (payload) => api.post("/applications/mentee", payload).then((r) => r.data);
export const applyMentor = (payload) => api.post("/applications/mentor", payload).then((r) => r.data);
export const applyVolunteer = (payload) => api.post("/applications/volunteer", payload).then((r) => r.data);
export const submitHelpRequest = (payload) => api.post("/help-requests", payload).then((r) => r.data);
export const submitReferral = (payload) => api.post("/school-referrals", payload).then((r) => r.data);
export const submitToolkitRequest = (payload) => api.post("/toolkit-requests", payload).then((r) => r.data);
export const createCheckout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sid) => api.get(`/payments/status/${sid}`).then((r) => r.data);
export const getKingsCircle = () => api.get("/kings-circle").then((r) => r.data);
export const getStats = () => api.get("/config/stats").then((r) => r.data.stats);

// ---- Auth-gated (member portal) ----
export const submitCheckin = (payload) => api.post("/checkin", payload).then((r) => r.data);
export const listMyCheckins = () => api.get("/checkin").then((r) => r.data);
export const listWallPosts = () => api.get("/wall/posts").then((r) => r.data);
export const createWallPost = (payload) => api.post("/wall/posts", payload).then((r) => r.data);
export const listComments = (postId) => api.get(`/wall/posts/${postId}/comments`).then((r) => r.data);
export const addComment = (postId, body) => api.post(`/wall/posts/${postId}/comments`, { body }).then((r) => r.data);
export const reactPost = (postId, emoji) => api.post(`/wall/posts/${postId}/react`, { emoji }).then((r) => r.data);

// ---- Admin ----
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminApplications = (status) => api.get("/admin/applications", { params: status ? { status } : {} }).then((r) => r.data);
export const adminUpdateApp = (id, status) => api.patch(`/admin/applications/${id}`, { status }).then((r) => r.data);
export const adminHelpRequests = (status) => api.get("/admin/help-requests", { params: status ? { status } : {} }).then((r) => r.data);
export const adminUpdateHelp = (id, status) => api.patch(`/admin/help-requests/${id}`, { status }).then((r) => r.data);
export const adminReferrals = () => api.get("/admin/referrals").then((r) => r.data);
export const adminMembers = () => api.get("/admin/members").then((r) => r.data);
export const adminDonors = () => api.get("/admin/donors").then((r) => r.data);
export const adminCheckins = () => api.get("/admin/checkins").then((r) => r.data);
export const adminWall = () => api.get("/admin/wall").then((r) => r.data);
export const adminModeratePost = (id, status) => api.patch(`/admin/wall/${id}`, { status }).then((r) => r.data);

export const adminListEvents = () => api.get("/admin/events").then((r) => r.data);
export const adminCreateEvent = (payload) => api.post("/admin/events", payload).then((r) => r.data);
export const adminUpdateEvent = (id, payload) => api.patch(`/admin/events/${id}`, payload).then((r) => r.data);
export const adminDeleteEvent = (id) => api.delete(`/admin/events/${id}`).then((r) => r.data);
export const adminUpdateStats = (stats) => api.patch("/admin/config/stats", { stats }).then((r) => r.data);
export const adminToolkitRequests = () => api.get("/admin/toolkit-requests").then((r) => r.data);

// ---- Programs config ----
export const getProgramStatus = () => api.get("/config/program-status").then((r) => r.data.status);
export const adminUpdateProgramStatus = (status) => api.patch("/admin/config/program-status", { status }).then((r) => r.data);

// ---- Enrollment ----
export const submitEnrollment = (payload) => api.post("/enrollments", payload).then((r) => r.data);
export const adminEnrollments = (status) => api.get("/admin/enrollments", { params: status ? { status } : {} }).then((r) => r.data);
export const adminUpdateEnrollment = (id, status) => api.patch(`/admin/enrollments/${id}`, { status }).then((r) => r.data);

// ---- Partnerships ----
export const submitPartnership = (payload) => api.post("/partnerships", payload).then((r) => r.data);
export const adminPartnerships = () => api.get("/admin/partnerships").then((r) => r.data);
export const adminUpdatePartnership = (id, status) => api.patch(`/admin/partnerships/${id}`, { status }).then((r) => r.data);

// ---- Resources (public) ----
export const listResources = (category) => api.get("/resources", { params: category ? { category } : {} }).then((r) => r.data);
export const resourceDownloadUrl = (id) => `${API_BASE}/resources/${id}/download`;

// ---- Resources (admin) ----
export const adminListResources = () => api.get("/admin/resources").then((r) => r.data);
export const adminUploadResource = (formData) =>
  api.post("/admin/resources", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const adminUpdateResource = (id, payload) => api.patch(`/admin/resources/${id}`, payload).then((r) => r.data);
export const adminDeleteResource = (id) => api.delete(`/admin/resources/${id}`).then((r) => r.data);
export const getNewHomeProgress = () => api.get("/new-home/progress").then((r) => r.data);
export const adminListGifts = () => api.get("/admin/new-home/gifts").then((r) => r.data);
export const adminAddGift = (payload) => api.post("/admin/new-home/gifts", payload).then((r) => r.data);
export const adminDeleteGift = (id) => api.delete(`/admin/new-home/gifts/${id}`).then((r) => r.data);
export const adminReplaceResource = (id, formData) =>
  api.post(`/admin/resources/${id}/replace`, formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const adminResourceDownloadUrl = (id) => `${API_BASE}/admin/resources/${id}/download`;

// ---- Blog ----
export const listBlog = (category) => api.get("/blog", { params: category ? { category } : {} }).then((r) => r.data);
export const getBlog = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const adminListBlog = () => api.get("/admin/blog").then((r) => r.data);
export const adminCreateBlog = (payload) => api.post("/admin/blog", payload).then((r) => r.data);
export const adminUpdateBlog = (id, payload) => api.patch(`/admin/blog/${id}`, payload).then((r) => r.data);
export const adminDeleteBlog = (id) => api.delete(`/admin/blog/${id}`).then((r) => r.data);

// ---- Leadership ----
export const listLeadership = () => api.get("/leadership").then((r) => r.data);
export const adminCreateLeader = (payload) => api.post("/admin/leadership", payload).then((r) => r.data);
export const adminUpdateLeader = (id, payload) => api.patch(`/admin/leadership/${id}`, payload).then((r) => r.data);
export const adminDeleteLeader = (id) => api.delete(`/admin/leadership/${id}`).then((r) => r.data);
